module.exports = __webpack_public_path__ + "static/media/x-circle-fill.92ddcfe1.svg";